import { sumBy } from 'lodash'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import NotApplicable from '@/components/common/NotApplicable/NotApplicable'

import styles from './CurriculumCourseBasketBlock.module.scss'
import type { CurriculumBasketCourseSemester } from '../queries/useCurriculumBasketCourse'

type CourseBasketBlockProps = {
  semesters: CurriculumBasketCourseSemester[]
}

const CurriculumCourseBasketBlock = (props: CourseBasketBlockProps) => {
  const { t } = useTranslation('sections')

  const columns: HoursColumnProps[] = useMemo(
    () => [
      ...props.semesters.map((semester, index) => ({
        header: t('label.semester', { ORDINAL: index + 1 }),
        hours: semester.isActive ? semester.hours : null
      })),
      {
        header: t('label.total'),
        hours: sumBy(props.semesters, ({ hours }) => hours ?? 0)
      }
    ],
    [props.semesters, t]
  )

  return (
    <div className={styles.container}>
      {columns.map(column => (
        <HoursColumn key={column.header} {...column} />
      ))}
    </div>
  )
}

type HoursColumnProps = {
  header: string
  hours: number | null
}

const HoursColumn = (props: HoursColumnProps) => (
  <div className={styles.column}>
    <span className={styles.header}>{props.header}</span>
    <span className={styles.value}>
      {typeof props.hours === 'number' ? `${props.hours}h` : <NotApplicable />}
    </span>
  </div>
)

export default CurriculumCourseBasketBlock
